import { render } from "./Reminder.vue?vue&type=template&id=6869563f&scoped=true"
import script from "./Reminder.vue?vue&type=script&lang=js"
export * from "./Reminder.vue?vue&type=script&lang=js"

import "./Reminder.vue?vue&type=style&index=0&id=6869563f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6869563f"]])

export default __exports__